<template>
  <div class="sidebar-overlay" v-if="showSidebar" @click="toggleSidebar()"></div>
  <nav class="sidebar" :class="{ 'sidebar-visible': showSidebar, 'sidebar-hidden': !showSidebar }">
  <div style="overflow-y: auto;">
    <ul class="nav flex-column">
      
      <!-- Dashboard -->
      <li class="nav-item position-relative pt-3">
        <router-link class="nav-link py-0 -ps-1" to="/home">
          <span>
            <LayoutDashboard :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Dashboard</span>
          </span>
        </router-link>
      </li>
      
      <!-- Quick Actions -->
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1" href="#" @click.prevent="openRequestModal()">
          <span>
            <PlusCircle :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">New Request</span>
          </span>
        </a>
      </li>
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1" href="#" @click.prevent="openAssignmentModal()">
          <span>
            <CheckSquare :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">New Task</span>
          </span>
        </a>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/clock/list">
          <span>
            <Clock :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Time Tracker</span>
          </span>
        </router-link>
      </li>
      
      <li><hr /></li>

      <!-- Main Navigation -->
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/request/list">
          <span>
            <ClipboardList :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Requests</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/job/list">
          <span>
            <FileText :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">WorkOrders</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/service-reports">
          <span>
            <ClipboardCheck :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Service Reports</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/calendar">
          <span>
            <Calendar :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Calendar / Schedule</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/pm/list">
          <span>
            <Wrench :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">PM's</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/procedures">
          <span>
            <ListChecks :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Procedures / Checklists</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/forms">
          <span>
            <FileEdit :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Client Documents</span>
          </span>
        </router-link>
      </li>
      
      <li><hr /></li>
      
      <!-- Quick Views Accordion -->
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1 accordion-toggle" href="#" @click.prevent="toggleAccordion('quickviews')">
          <span>
            <Zap :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Quick Views</span>
            <ChevronRight :size="16" class="accordion-chevron" :class="{ 'rotated': openAccordion === 'quickviews' }" />
          </span>
        </a>
        <ul class="nav flex-column accordion-content" :class="{ 'open': openAccordion === 'quickviews' }">
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" :to="{ path: '/job/list', query: { status: 2, page: 0 } }">
              <span>
                <CheckCircle :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Work Complete</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" :to="{ path: '/job/list', query: { status: 10, page: 0 } }">
              <span>
                <Clock :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Awaiting PO</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" :to="{ path: '/job/list', query: { status: 11, page: 0 } }">
              <span>
                <Headphones :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Customer Support</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" :to="{ path: '/job/list', query: { status: 12, page: 0 } }">
              <span>
                <Settings :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Maintenance</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" :to="{ path: '/job/list', query: { status: 19, page: 0 } }">
              <span>
                <RefreshCw :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Renewals</span>
              </span>
            </router-link>
          </li>
        </ul>
      </li>
      
      <li><hr /></li>
      
      <!-- Billing Section -->
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/estimates">
          <span>
            <FileText :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Estimates</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/workorders">
          <span>
            <Receipt :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Invoices</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/purchase-orders">
          <span>
            <ShoppingCart :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Purchase Orders</span>
          </span>
        </router-link>
      </li>
      
      <li><hr /></li>

      <!-- Company Accordion -->
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1 accordion-toggle" href="#" @click.prevent="toggleAccordion('company')">
          <span>
            <Building :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Company</span>
            <ChevronRight :size="16" class="accordion-chevron" :class="{ 'rotated': openAccordion === 'company' }" />
          </span>
        </a>
        <ul class="nav flex-column accordion-content" :class="{ 'open': openAccordion === 'company' }">
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/client/list">
              <span>
                <Building :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Customers</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/vendors">
              <span>
                <Truck :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Vendors / Contractors</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/part/list">
              <span>
                <Package :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Parts & Inventory</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/expense/list">
              <span>
                <Banknote :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Expenses</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/mileage/list">
              <span>
                <Car :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Mileage</span>
              </span>
            </router-link>
          </li>
        </ul>
      </li>
      
      <li><hr /></li>
      
      <!-- Administrative Accordion -->
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1 accordion-toggle" href="#" @click.prevent="toggleAccordion('administrative')">
          <span>
            <Settings :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Administrative</span>
            <ChevronRight :size="16" class="accordion-chevron" :class="{ 'rotated': openAccordion === 'administrative' }" />
          </span>
        </a>
        <ul class="nav flex-column accordion-content" :class="{ 'open': openAccordion === 'administrative' }">
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/tech/list">
              <span>
                <Users :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">User / Technician Setup</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/settings">
              <span>
                <Settings :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Settings</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/gps-tracker">
              <span>
                <MapPin :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">GPS Tracker</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/admin-reports">
              <span>
                <BarChart2 :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Admin Reports</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/resource-manager">
              <span>
                <FolderOpen :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Resource Manager</span>
              </span>
            </router-link>
          </li>
        </ul>
      </li>
      
      <li><hr /></li>
      
      <!-- Payroll Accordion -->
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1 accordion-toggle" href="#" @click.prevent="toggleAccordion('payroll')">
          <span>
            <DollarSign :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Payroll</span>
            <ChevronRight :size="16" class="accordion-chevron" :class="{ 'rotated': openAccordion === 'payroll' }" />
          </span>
        </a>
        <ul class="nav flex-column accordion-content" :class="{ 'open': openAccordion === 'payroll' }">
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/timesheets">
              <span>
                <Clock :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">My Timesheets</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/time-off-request">
              <span>
                <Calendar :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Request Time Off</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/pto-report">
              <span>
                <FileText :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">PTO Report</span>
              </span>
            </router-link>
          </li>
        </ul>
      </li>

    </ul>
  </div>
  <div>
    <ul class="nav flex-column">
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/logout">
          <span>
          <LogOut :size="20" class="position-absolute mt-1" />
          <span class="d-inline-block ms-4 ps-2">Logout</span>
          </span>
        </router-link>
      </li>
    </ul>
    <div class="version d-flex align-items-center justify-content-between">
      <span>v{{ appVersion }}</span>
      <a href="#" class="refresh-link" @click.prevent="refreshApp" title="Clear cache and reload">
        <RefreshCw :size="14" /> Refresh
      </a>
    </div>
  </div>
  </nav>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { RouterLink } from "vue-router";
import Emitter from "@/services/Emitter";
import ApiService from "@/services/ApiService";
import { 
  Home, 
  PlusCircle, 
  CheckSquare, 
  UserCheck,
  FileText, 
  List, 
  Building, 
  Users, 
  Calendar, 
  Package, 
  Banknote, 
  Car, 
  Wrench, 
  Clock, 
  RotateCcw, 
  LogOut,
  ClipboardList,
  ChevronRight,
  FolderOpen,
  BarChart2,
  Bell,
  FileEdit,
  RefreshCw,
  CreditCard,
  Settings,
  LayoutDashboard,
  Zap,
  CheckCircle,
  Receipt,
  DollarSign,
  ClipboardCheck,
  ListChecks,
  Headphones,
  ShoppingCart,
  Truck,
  MapPin
} from 'lucide-vue-next';

const appVersion = __APP_VERSION__;

const isMobile = () => window.innerWidth <= 768;
const showSidebar = ref(!isMobile());
const openAccordion = ref<string | null>(null);
const unreadCount = ref(0);

const loadUnreadCount = async () => {
  try {
    unreadCount.value = await ApiService.getUnreadNotificationCount(true);
  } catch (error) {
    console.error('Error loading unread count:', error);
  }
};

onMounted(() => {
  loadUnreadCount();
  // Emit initial sidebar state so layout knows if sidebar is visible
  Emitter.emit("sidebar-state", showSidebar.value);
});

Emitter.on("notification:refresh", loadUnreadCount);

const toggleSidebar = () => {
  showSidebar.value = !showSidebar.value;
  Emitter.emit("sidebar-state", showSidebar.value);
};

const toggleAccordion = (section: string) => {
  if (openAccordion.value === section) {
    openAccordion.value = null;
  } else {
    openAccordion.value = section;
  }
};

Emitter.on("sidebar", toggleSidebar);

const openJobModal = () => {
  Emitter.emit("open:requestForm");
};

const openAssignmentModal = () => {
  Emitter.emit("open:taskForm");
};

const openRequestModal = () => {
  Emitter.emit("open:requestForm");
};

const refreshApp = async () => {
  // Clear caches and do a hard refresh
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
      console.log('Caches cleared');
    } catch (e) {
      console.error('Failed to clear caches:', e);
    }
  }
  
  // Clear localStorage app-specific items (preserve auth)
  const keysToKeep = ['token', 'user'];
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && !keysToKeep.includes(key)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
  
  // Hard refresh bypassing cache
  window.location.reload();
};
</script>

<style scoped>
.sidebar {
  width: 300px;
  max-width: 300px;
  background-color: rgb(34,30,31);
  background-color: #132341;
  color: #ffffff;
  height: calc(100vh - 70px);
  position: fixed;
  top: 70px;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index:1000;
  transition: transform 0.3s ease-in-out;
}

.sidebar-visible {
  transform: translateX(0);
}

.sidebar-hidden {
  transform: translateX(-100%);
}
.sidebar .nav-link {
  color: #adb5bd;
  /* padding: 0.75rem 1.5rem; */
}

.sidebar .nav-link > span {
  display: block;
  padding: 0.75rem 1.5rem;
  position: relative;
  overflow: hidden;
  /* border-radius: 50px; */
}

/* Hover effect - aquamarine green badge style */
.sidebar .nav-link:hover > span {
  color: #ffffff;
  background-color: #3B9796;
  transition: background-color 0.2s ease;
}

.sidebar .nav-link:hover > span svg {
  color: #ffffff;
}

/* Commented out: Glow/shimmer hover effect
.sidebar .nav-link:hover > * {
  color: #ffffff; 
  transition: padding-left 0.4s;
  padding-left: 2rem!important;
}
.sidebar .nav-link:hover > *:not(span) {
  color: #BF092F!important;
}

.sidebar .nav-link:hover > span {
  background-color: #495057;
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.sidebar .nav-link:hover > span i:last-child {
  display: inline-block!important;
}

.sidebar .nav-link:hover > span::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shimmer 1.5s ease-in-out;
  pointer-events: none;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
*/

/* Active page styles - match hover state */
.sidebar .nav-link.router-link-active > span {
  color: #ffffff;
  background-color: #3B9796;
}

.sidebar .nav-link.router-link-active > span svg {
  color: #ffffff;
}

.sidebar .version {
  padding: 0.75rem 1rem;
  color: #6c757d;
  font-size: 0.8rem;
}

.sidebar .version .refresh-link {
  color: #6c757d;
  text-decoration: none;
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  transition: color 0.2s ease;
}

.sidebar .version .refresh-link:hover {
  color: #3B9796;
}

.sidebar-overlay {
  position: fixed;
  top: 70px;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index:999;
}

@media (min-width: 769px) {
  .sidebar-overlay {
    display: none; /* No overlay needed on desktop */
  }
}

/* Accordion styles */
.accordion-toggle > span {
  display: flex;
  align-items: center;
}

.accordion-chevron {
  position: absolute;
  right: 1.5rem;
  transition: transform 0.3s ease;
}

.accordion-chevron.rotated {
  transform: rotate(90deg);
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: max-height 0.3s ease-out, opacity 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.25);
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.3);
}

.accordion-content.open {
  max-height: 500px;
  opacity: 1;
  transition: max-height 0.4s ease-in, opacity 0.4s ease-in;
}

.accordion-content .sub-item > span {
  padding-left: 1.5rem !important;
}
</style>